// app/javascript/modules/admissoes/pensao.js
// Mostra/oculta a seção de upload do documento de pensão alimentícia
// conforme a seleção do radio params[pensao_alimenticia].

export function initPensao($form, h) {
  const { hide, show } = h
  const ns = '.admissaoPensao'

  function apply() {
    const checked = $form.find('input[name="params[pensao_alimenticia]"]:checked').val()
    const $secao = $form.find('#secao-pensao-docs')
    if (!$secao.length) return

    const $fileInput = $secao.find('input[type="file"]')

    if (checked === 'Sim') {
      show($secao)
      const jaAnexado = !!$secao.find('a[target="_blank"]').length
      if (!jaAnexado) $fileInput.attr('required', true)
    } else {
      hide($secao)
      $fileInput.removeAttr('required')
    }
  }

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[pensao_alimenticia]"]', apply)

  return {
    apply,
    destroy() { $form.off(ns) }
  }
}
